export default {"src":"/coding-school/_next/static/media/Investor_side_logo.2d3a2fe8.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};